<script>
import { onMount, tick } from 'svelte';
import Frame from './Frame.svelte';
import Messages from './Messages.svelte';
import { createEditor } from '../editor';
import { Delta } from '@typewriter/editor';
import { user } from '../data/user';
import { createChatStore } from '../data/server';
import { writable } from '../libs/store';
import { tooltipTop } from '../tooltip';

export let sprintId;
export let disabled = false;

const sprintIdStore = writable(sprintId);
const chats = createChatStore(user, sprintIdStore);
window.chats = chats;

$: $sprintIdStore = sprintId;
$: editor && editor.view.enable(!disabled);

let messages = [];
let input;
let editor;

async function onKeyDown(event) {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const content = getContent();
    editor.setContents(new Delta().insert('\n'));

    if (content.length() > 1) {
      await tick();
      await tick();
      chats.send(content);
    }
  }
}

function getContent() {
  let offset = 0;
  const trimDelta = new Delta();
  const text = editor.getExactText();

  text.replace(/^\s+|\s+$|(\s{3,})/g, (match, middle, index) => {
    const spaces = middle ? Math.min(match.length, 2) : 0;
    trimDelta.retain(index - offset).delete(match.length - spaces);
    offset = index + match.length - spaces;
  });

  return editor.getContents().compose(trimDelta);
}

onMount(() => {
  editor = createEditor(input);
  editor.view.paper.blocks.remove('header');
  editor.view.paper.blocks.remove('blockquote');
});
</script>

<div class="chat">
  <div class="messages">
    <div class="message-overlay"></div>
    <Frame class="frame" messages={$chats} {disabled} component={Messages}/>
  </div>
  <div class="chat-input" bind:this={input} on:keydown={onKeyDown} placeholder={disabled ? '' : 'Send a message'}></div>
</div>

<style>
.chat {
  flex: 1;
  display: flex;
  flex-direction: column;
  contain: layout;
  min-height: 256px;
}
.messages {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.message-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .3);
  pointer-events: none;
  background-size: 100% 50px;
}
.chat :global(.frame) {
  flex: 1;
  height: auto;
}
.chat-input {
  margin-top: 4px;
  border: none;
  resize: none;
  padding: 8px;
  min-height: 32px;
  line-height: 16px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .3);
  font-size: var(--font-size-050);
  background: var(--white);
}
.chat-input:focus {
  outline: none;
}
.chat :global(p) {
  margin: 0;
}
.chat :global(blockquote) {
  margin: 0 0 0 4px;
  padding: 0 0 0 8px;
  border-left: 1px solid var(--warm-grey-200);
}
.chat :global(.chat-input[contenteditable="false"]) {
  background: var(--warm-grey-050);
}
</style>
